import { render, staticRenderFns } from "./ElementMenu.vue?vue&type=template&id=1c0b0960"
import script from "./ElementMenu.vue?vue&type=script&lang=js"
export * from "./ElementMenu.vue?vue&type=script&lang=js"
import style0 from "./ElementMenu.vue?vue&type=style&index=0&id=1c0b0960&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports